var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "el-button",
        {
          staticClass: "hq-button",
          attrs: {
            type: "success",
            icon: "el-icon-s-check",
            disabled: _vm.setTransrefseach
          },
          on: { click: _vm.transferClick }
        },
        [_vm._v("查询转移")]
      ),
      _c(
        "HqModal",
        {
          attrs: { visible: _vm.transferShow, title: "转移", width: "480" },
          on: { "on-cancel": _vm.cancel }
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.formRules } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24, prop: "mode" } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("CheckBox", {
                            ref: "CheckBoxname",
                            attrs: {
                              label: "规则",
                              list: _vm.checkList,
                              select: _vm.form.mode
                            },
                            on: {
                              "update:select": function($event) {
                                return _vm.$set(_vm.form, "mode", $event)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.form.mode !== 2
                    ? _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "14px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "deptId" } },
                            [
                              _c("SelectTree", {
                                ref: "deptsys",
                                attrs: {
                                  labelName: "部门",
                                  data: _vm.deptList,
                                  label: "deptName",
                                  value: "deptId",
                                  select: _vm.form.deptId
                                },
                                on: {
                                  "update:select": [
                                    _vm.select,
                                    function($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "deptId",
                                        $event
                                      )
                                    }
                                  ]
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.permUtil.WbCusotmer.transferChange() && _vm.form.mode == 1
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.sign,
                                callback: function($$v) {
                                  _vm.sign = $$v
                                },
                                expression: "sign"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                { attrs: { label: "是否变更部门", value: 1 } },
                                [_vm._v("是否变更部门")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.mode == 1
                    ? _c(
                        "el-col",
                        {
                          staticStyle: { "margin-top": "14px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "userId" } },
                            [
                              _c("SelectMultiple", {
                                ref: "user",
                                attrs: {
                                  select: _vm.form.userId,
                                  label: "人员",
                                  items: _vm.userArr,
                                  itemText: "userName",
                                  itemValue: "userId"
                                },
                                on: {
                                  "update:select": function($event) {
                                    return _vm.$set(_vm.form, "userId", $event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingbtn, type: "primary" },
                  on: { click: _vm.save }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "HqModal",
        {
          attrs: {
            visible: _vm.transferShowtishi,
            title: "转移",
            width: "420"
          },
          on: { "on-cancel": _vm.canceltishi }
        },
        [
          _c("div", [
            _vm._v(" 根据查询条件，当前符合转移条件的商机有"),
            _c("span", { staticClass: "spantitle" }, [
              _vm._v(_vm._s(_vm.total))
            ]),
            _vm._v("条， "),
            _c("span", { staticStyle: { color: "red" } }, [
              _vm._v("转移操作为不可逆操作")
            ]),
            _vm._v("，请确认是否转移？ ")
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.canceltishi } }, [
                _vm._v("取消")
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.savetishi } },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }